import React from 'react';

export const TaskListTableSkeleton = ({ rows = 6 }) => {
    return Array.from({ length: rows }).map((_, index) => (
        <tr key={`ticket-skeleton-${index}`} className="ticket-ops-row ticket-ops-row--skeleton">
            <td><span className="ticket-skeleton-line ticket-skeleton-line--xs" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--sm" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--lg" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--md" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--md" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--md" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--sm" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--md" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--sm" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--md" /></td>
            <td><span className="ticket-skeleton-line ticket-skeleton-line--md" /></td>
        </tr>
    ));
};